import { render, staticRenderFns } from "./ContactLink.vue?vue&type=template&id=c8acdb7a&scoped=true"
import script from "./ContactLink.vue?vue&type=script&lang=js"
export * from "./ContactLink.vue?vue&type=script&lang=js"
import style0 from "./ContactLink.vue?vue&type=style&index=0&id=c8acdb7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8acdb7a",
  null
  
)

export default component.exports